// © Microsoft Corporation. All rights reserved.
/**
 * Headers used for OneService requests
 */
export const oneServiceHeaders = {
    activityId: "x-client-activityid",
    authorization: "Authorization"
};
/**
 * used query string params in OneService requests
 */
export const oneServiceQueryStringKeys = {
    activityId: "activityId",
    apiKey: "apikey",
    complexInfoPaneEnabled: "cipenabled",
    contentType: "contentType",
    delta: "delta",
    disableTypeSerialization: "DisableTypeSerialization",
    infopaneCount: "infopaneCount",
    fdhead: "fdhead",
    filter: "$filter",
    ids: "ids",
    location: "location",
    market: "market",
    ocid: "ocid",
    parentContentId: "parent-content-id",
    parentNamespace: "parent-ns",
    parentTitle: "parent-title",
    query: "query",
    queryType: "queryType",
    qScope: "qscope",
    responseSchema: "responseSchema",
    select: "$select",
    signInCookieName: "scn",
    skip: "$skip",
    source: "source",
    timeOut: "timeOut",
    top: "$top",
    user: "user",
    wrapOData: "wrapodata",
    feedLayoutRequestType: "t"
};
//# sourceMappingURL=OneServiceConstants.js.map